import { registerBlockType } from '@wordpress/blocks';
import { InnerBlocks } from '@wordpress/block-editor';

import metadata from '../block.json';
import Edit from './Edit';
import './editor.scss';
import { teamMembersIcon } from './utils/icons';

registerBlockType(metadata, {
	icon: teamMembersIcon,

	// Build in Functions
	edit: Edit,

	save: () => <InnerBlocks.Content />
});